import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Terms from "../pages/Terms";
import PrivacyPolicyEn from "../pages/PrivacyPolicyEn";
import TermsEn from "../pages/TermsEn";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/en/privacy",
    element: <PrivacyPolicyEn />,
  },
  {
    path: "/en/terms",
    element: <TermsEn />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
